import React, { useState, useContext } from "react";
import ProjectForm from "./ProjectForm";
// import { useState } from "react";
import firebase from "../firebase";
import { TodoContext } from "../context";

export default function RenameProject({ project, setShowModal }) {
  //STATE
  const [newProjectName, setNewProjectName] = useState(project.name);
  //CONTEXT
  const { selectedProject, setSelectedProject } = useContext(TodoContext);

  const renameProject = (project, newProjectName) => {
    const projectsRef = firebase.firestore().collection("projects");
    const todosRef = firebase.firestore().collection("todos");
    const { name: oldProjectName } = project;

    projectsRef
      .where("name", "==", newProjectName)
      .get()
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          alert("project with the same name already exists!");
        } else {
          projectsRef
            .doc(project.id)
            .update({
              name: newProjectName,
            })
            .then(() => {
              todosRef
                .where("projectName", "==", oldProjectName)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    doc.ref.update({
                      projectName: newProjectName,
                    });
                  });
                });
            })
            .then(() => {
              if (oldProjectName === selectedProject) {
                setSelectedProject(newProjectName);
              }
            });
        }
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    renameProject(project, newProjectName);
    setShowModal(false);
  };
  return (
    <div className="EditProject">
      <ProjectForm
        handleSubmit={handleSubmit}
        heading="edit project name"
        value={newProjectName}
        setValue={setNewProjectName}
        setShowModal={setShowModal}
        confirmButtonText="confirm"
      />
    </div>
  );
}
